import { FC } from 'react';

export const Empty: FC<{ msg: string; icon?: string, nonIcon?: boolean }> = ({ msg, icon, nonIcon }) => (
  <div className="empty-box">
    {
      nonIcon !== true && <img src={icon || 'https://xyp.qpic.cn/gwb/images/empty.png'} className="empty-icon" />
    }
    <span className="empty-text">{msg}</span>
  </div>
);
